export const ALL_AGENCY_TYPES = 0;

// Mirrors the backend ISubjectKeyed.URGENT_MESSAGE_PRIORITY_ID: messages have no priority entity, so
// urgent MESSAGE_PRIORITY action rows use this fixed subject id.
export const URGENT_MESSAGE_PRIORITY_ID = 1;
